import Enum from "../../enums/Enum";

const YesNoEnum = new Enum({
        YES: {name: "Yes"},
        NO: {name: "No"}
});

export default YesNoEnum;